const price = {
  namespaced: true,

  state: {
    priceDetail: undefined,
  },

  getters: {},

  mutations: {
    setPriceDetail(state, value) {
      state.priceDetail = value;
    },
  },

  actions: {},
};

export default price;
